import { config } from '../_common/stitches/stitches.config.js';
const JPEG_VALID_FORMATS = ['.jpg', '.jpeg', '.jfif', '.pjpeg', '.pjp'];
const getImageTypeFromFormat = imageSource => {
  if (JPEG_VALID_FORMATS.some(format => imageSource.includes(format))) {
    return 'image/jpeg';
  }
  if (imageSource.includes('.svg')) {
    return 'image/svg+xml';
  }
  const imageSourceWithoutQueryParams = imageSource.split('?').shift();
  return `image/${imageSourceWithoutQueryParams === null || imageSourceWithoutQueryParams === void 0 ? void 0 : imageSourceWithoutQueryParams.split('.').pop()}`;
};
const getSourceSetMedia = media => {
  if (!media) {
    return config.media.xsMin;
  }
  return config.media[media] ? config.media[media] : media;
};
export { JPEG_VALID_FORMATS, getImageTypeFromFormat, getSourceSetMedia };